import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Please ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" and then contact your storeadmin for help. ")

import { useAuth0 } from "@auth0/auth0-vue";
import { MutationTypes } from "../store/mutations";
import { useStore } from 'vuex';
import { computed, inject } from 'vue';
import { errorContent } from '@/composables/useErrorLog';


export default /*#__PURE__*/_defineComponent({
  name: 'StoreDisable',
  setup(__props) {

const auth0 = useAuth0();
const store = useStore();
const posthog = inject("posthog");
const error = computed(() => { return errorContent.value != undefined ? JSON.parse(errorContent.value) : {message: 'This store is disabled'} });

const logout = () => {
  store.commit(MutationTypes.SET_INITIALLOGIN, false);
  const email = auth0.user.value.email;
  posthog.capture("logout_button_clicked", { email: email });
  sessionStorage.removeItem('vuex');
  localStorage.clear();
  auth0.logout({
    returnTo: window.location.origin
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref(error).message), 1),
      _createElementVNode("p", null, [
        _hoisted_3,
        _createElementVNode("a", {
          id: "qsLogoutBtn",
          href: "#",
          class: "",
          onClick: _withModifiers(logout, ["prevent"])
        }, "Log out", 8, _hoisted_4),
        _hoisted_5
      ])
    ])
  ]))
}
}

})